import { motion } from "framer-motion";
import { useSite } from "@/context/SiteContext";
import Reveal, { fadeUp, stagger } from "./Reveal";

export default function Stats() {
  const { content, t } = useSite();
  const stats = content?.stats || [];
  if (!stats.length) return null;

  return (
    <section className="border-y border-white/10 bg-brand-ink/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          className="grid grid-cols-2 lg:grid-cols-4 gap-10"
        >
          {stats.map((s, i) => (
            <motion.div key={i} variants={fadeUp} className="text-center lg:text-left">
              <p className="font-display text-5xl sm:text-6xl text-transparent bg-clip-text bg-[linear-gradient(90deg,#2E9BE8,#F97316)]">
                {s.value}
              </p>
              <p className="mt-2 font-mono2 text-xs uppercase tracking-[0.2em] text-white/60">{t(s.label)}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
